'use strict';

angular.module('amexReconciliationApp')
  .service('InitService', function InitService(UserRepository,
                                               UserPreferencesRepository,
                                               UserModel,
                                               FeatureFlagModel,
                                               $state, $q, $translate) {
    var self = this;

    self.init = function () {
      if (UserModel.currentUser()) {
        return $q.when();
      }

      return FeatureFlagModel.retrieveFeatureFlags()
        .then(UserRepository.getAuthenticatedUser)
        .then(UserModel.fetchPreferences)
        .then(updateCurrentUser)
        .then(updatePreviousUser)
        .catch(onFetchDataError);
    };

    function updateCurrentUser(user) {

      UserModel.setCurrentUser(user);

      if (user.preferredLanguage) {
        $translate.use(user.preferredLanguage.toLowerCase());
      }

      return UserRepository.getPreviousUser();
    }

    function updatePreviousUser(previousUser) {
      UserModel.previousUser = previousUser;

      if (!previousUser.username) {
        UserModel.previousUser = null;
      }
    }

    function onFetchDataError() {
      $state.go('error');
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/InitService.js
// module id = 640
// module chunks = 0